"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.genOrderStyle = exports.genWidthClass = void 0;
function genWidthClass(context, props) {
    var width = 1;
    if (props.width) {
        width = props.width;
    }
    if (context) {
        if (props.xlWidth && context.breakpoint.index <= 4) {
            width = props.xlWidth;
        }
        if (props.lWidth && context.breakpoint.index <= 3) {
            width = props.lWidth;
        }
        if (props.mWidth && context.breakpoint.index <= 2) {
            width = props.mWidth;
        }
        if (props.sWidth && context.breakpoint.index <= 1) {
            width = props.sWidth;
        }
        if (props.xsWidth && context.breakpoint.index <= 0) {
            width = props.xsWidth;
        }
    }
    return " col-" + width;
}
exports.genWidthClass = genWidthClass;
function genOrderStyle(context, props) {
    var order = null;
    if (context) {
        if (props.xlOrder && context.breakpoint.index <= 4) {
            order = props.xlOrder;
        }
        if (props.lOrder && context.breakpoint.index <= 3) {
            order = props.lOrder;
        }
        if (props.mOrder && context.breakpoint.index <= 2) {
            order = props.mOrder;
        }
        if (props.sOrder && context.breakpoint.index <= 1) {
            order = props.sOrder;
        }
        if (props.xsOrder && context.breakpoint.index <= 0) {
            order = props.xsOrder;
        }
    }
    if (order) {
        return { order: order };
    }
    else {
        return undefined;
    }
}
exports.genOrderStyle = genOrderStyle;
